import arrayWithHoles from "./arrayWithHoles";
import iterableToArrayLimit from "./iterableToArrayLimit";
import nonIterableRest from "./nonIterableRest";
export default function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/slicedToArray.js
// module id = 53
// module chunks = 0